module.exports = __webpack_public_path__ + "img/product4.278a603b.png";